import Collapse from "@material-ui/core/Collapse";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  AttendanceDevice,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import web from "../../../../../Assets/Images/web.svg";
import SelectList from "../../../../../Component/SelectList/SelectList";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
  menuItem: {
    "&:focus": {
      backgroundColor: "#2ecaff29",
      "& $primary, & $icon": {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
});

class Web extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      iswebdevice: true,
      isiprestricted: false,
      ipAddresslist: [],
      selectedOptions: [],
      ErList: false,
      allowedweddeviceip: [],
      helperText: "",
      isbidirection: false,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("attendancedevicepolicy");
    this.GetIpAdressList();
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);

    this.props.onRef({
      onNext: this.OnNext,
    });

    const text = this.props.Language.attendancedevicepolicy.HtWeb;
    this.props.setHelperText({ helperText: text });
    let iswebdevice = false;
    let isiprestricted = false;
    let selectedOptions = [];
    let allowedweddeviceip = [];
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    if (!this.isEmpty(attendanceDeviceInfo)) {
      const { isbidirection } = attendanceDeviceInfo;
      const isdraft = attendanceDeviceInfo.isdraft != false;
      if (isbidirection == true) {
        iswebdevice = false;
        isiprestricted = false;
        allowedweddeviceip = [];
      } else {
        iswebdevice = attendanceDeviceInfo.iswebdevice != false;
        isiprestricted = attendanceDeviceInfo.isiprestricted == true;
        allowedweddeviceip = attendanceDeviceInfo.allowedweddeviceip
          ? attendanceDeviceInfo.allowedweddeviceip
          : [];
        allowedweddeviceip.forEach((option) => {
          if (option.ipaddresslist.length > 0) {
            option.ipaddresslist.forEach((listItem) => {
              selectedOptions = this.state.ipAddresslist.filter(
                (x) => x.officeaddressipid == listItem.officeaddressipid,
              );
              // console.log('selectedOptions: ', selectedOptions);
            });
          }
        });
      }
      this.setState(
        {
          iswebdevice,
          isiprestricted,
          allowedweddeviceip,
          selectedOptions,
          isdraft,
          isbidirection,
        },
        () => {
          this.UpdateAttendanceDeviceReducer();
        },
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(4, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  GetIpAdressList() {
    instance
      .get("/attendance/allofficeaddressips")
      .then((result) => {
        let selectedOptions = [];
        let ipAddresslist = [];
        result.data.result.length > 0
          ? (ipAddresslist = result.data.result)
          : (ipAddresslist = []);
        if (this.state.allowedweddeviceip.length > 0) {
          this.state.allowedweddeviceip.forEach((option) => {
            if (option.ipaddresslist.length > 0) {
              option.ipaddresslist.forEach((listItem) => {
                const selectedOptions1 = ipAddresslist.filter(
                  (x) => x.officeaddressipid == listItem.officeaddressipid,
                );
                selectedOptions = [...this.state.selectedOptions, ...selectedOptions1];
                this.setState({ selectedOptions });
                // console.log('selectedOptions: ', selectedOptions);
              });
            }
          });
        }
        this.setState({ ipAddresslist, selectedOptions });
        console.log('selectedOptionsnew: ', selectedOptions);
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  UpdateIsWebDevice(HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    if (selectedItem.displayvalue == false) {
      this.setState({
        selectedOptions: [],
        isautopunch: false,
        ispunchoutofradius: false,
        isiprestricted: false,
        ErList: false,
        allowedweddeviceip: [],
      });
    }
    this.setState({ iswebdevice: selectedItem.displayvalue }, () => {
      this.UpdateAttendanceDeviceReducer();
    });
  }

  SetTrue() {
    this.HelperSliderFlag("HtEnforceIPNetworkRestrictions");
    const isiprestricted = !this.state.isiprestricted;
    if (isiprestricted == false) {
      this.props.StepError(4, false);
      this.setState(
        {
          selectedOptions: [],
          isautopunch: false,
          ispunchoutofradius: false,
          ErList: false,
          allowedweddeviceip: [],
        },
        () => {
          this.UpdateAttendanceDeviceReducer();
        },
      );
    }
    this.setState({ isiprestricted }, () => {
      this.Validate();
      this.UpdateAttendanceDeviceReducer();
    });
  }

  SetFalse() {
    this.HelperSliderFlag("HtEnforceIPNetworkRestrictions");
    this.props.StepError(4, false);
    this.setState(
      {
        isiprestricted: false,
        selectedOptions: [],
        ErList: false,
        allowedweddeviceip: [],
      },
      () => {
        this.UpdateAttendanceDeviceReducer();
      },
    );
  }

  HandleMultiSelect = (selectedOption) => {
    // this.HelperSliderFlag([HtField])
    const { selectedOptions } = this.state;
    const index = this.state.selectedOptions.findIndex(
      (item) => item.displayvalue == selectedOption.displayvalue,
    );
    if (index == -1) {
      selectedOptions.push(selectedOption);
    } else {
      selectedOptions.splice(index, 1);
    }

    const allowedweddeviceip = [];
    selectedOptions.forEach((option) => {
      const obj = {
        allowedweddeviceipid: option.allowedweddeviceipid
          ? option.allowedweddeviceipid
          : 0,
        officeaddressid: option.officeaddressid,
        locationname: option.locationname,
        iptype: option.codename,
        fromip: option.ipaddressfrom,
        toip: option.ipaddressto,
        ipaddresslist: [],
      };
      const filteredOptions = selectedOptions.filter(
        (x) => x.officeaddressid == option.officeaddressid,
      );
      filteredOptions.forEach((opt) => {
        const item = {
          officeaddressipid: opt.officeaddressipid,
        };
        obj.ipaddresslist.push(item);
      });

      const indextemp = allowedweddeviceip.findIndex(
        (x) => x.officeaddressid == option.officeaddressid,
      );
      if (indextemp == -1) {
        allowedweddeviceip.push(obj);
      }
    });
    this.setState({ selectedOptions, allowedweddeviceip }, () => {
      this.Validate();
      this.UpdateAttendanceDeviceReducer();
    });
  };

  UpdateAttendanceDeviceReducer = () => {
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    attendanceDeviceInfo.iswebdevice = this.state.iswebdevice;
    attendanceDeviceInfo.isiprestricted = this.state.isiprestricted;
    attendanceDeviceInfo.allowedweddeviceip = this.state.allowedweddeviceip;
    this.props.AttendanceDevice({ ...attendanceDeviceInfo });
  };

  Validate = () => {
    let isValid;
    if (
      this.state.isiprestricted == true
      && this.state.allowedweddeviceip.length == 0
    ) {
      this.setState({ ErList: true });
      this.props.StepError(4, true);
      isValid = false;
    } else {
      this.setState({ ErList: false });
      this.props.StepError(4, false);
      isValid = true;
    }
    return isValid;
  };

  OnNext = () => {
    if (this.Validate()) {
      this.UpdateAttendanceDeviceReducer();
      this.props.click();
    }
  };

  OnSave = (flag) => {
    if (this.Validate()) {
      this.UpdateAttendanceDeviceReducer();
      this.props.SaveDevicePolicy(flag);
    }
  };

  OnCancel() {
    this.props.Cancel(true);
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.attendancedevicepolicy[${HtField}]`);
    // let text = this.props.Language.attendancedevicepolicy[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    const { classes } = this.props;
    const { selectedOptions } = this.state;

    let selectedIDObj = [];
    const options = [
      {
        displayvalue: true,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: false,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    return (
      <div className={classes.root}>
        <div className="stepper-scroller padding-top-0">
          <div className="stepper-scroller-content">
            <div className="inner-wrapper">
              <div className="opaque">
                {this.state.isbidirection == true ? (
                  <div className="">
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="LbWebBrowsersCantRegister"
                        defaultMessage="Web browsers can't register 'in & out' direction of an employee. You have used directional biometric devices, we recommend you to review your biometric set-up."
                      />
                    </p>
                  </div>
                ) : (
                    <div className="">
                      <div>
                        <p className="depedent-select-list-head">
                          <FormattedMessage
                            id="LbEnableWebBasedAttendance"
                            defaultMessage="Would you like to enable web based attendance via Windows/Linux/Mac browser"
                          />
                        </p>
                        <div className="device-form-img">
                          <img src={web} align="left" height="100" />
                        </div>
                        <div>
                          <SelectList
                            data={options}
                            Selected={this.state.iswebdevice}
                            onSelected={this.UpdateIsWebDevice.bind(
                              this,
                              "HtEnableWebBasedAttendance",
                            )}
                          />
                        </div>
                      </div>
                      {this.state.iswebdevice == true ? (
                        <div className="margin-top-10">
                          <p className="depedent-select-list-head">
                            <FormattedMessage
                              id="LbEnforceIPNetworkRestrictions"
                              defaultMessage="Would you like to enforce IP Network restrictions as well"
                            />
                          </p>
                          <div
                            className={
                              this.state.isiprestricted == true
                                ? "depedent-select-list select-list-item"
                                : "depedent-select-list"
                            }
                            onClick={this.SetTrue.bind(this)}
                          >
                            <span>
                              <FormattedMessage id="LbYes" defaultMessage="Yes" />
                            </span>
                            {this.state.isiprestricted == true ? (
                              <span className="floatright">
                                <img src={CheckImg} height="20" />
                              </span>
                            ) : (
                                <span className="not-selected"></span>
                              )}
                          </div>
                          {this.state.isiprestricted == true ? (
                            <div className="bottom-border"></div>
                          ) : (
                              ""
                            )}
                          <div className="inner-level-div iplist-attendence">
                            <Collapse
                              in={this.state.isiprestricted}
                              timeout="auto"
                              unmountOnExit
                              className="overflow-initial first-level-padding"
                            >
                              <MenuList>
                                <p className="depedent-select-list-head">
                                  <FormattedMessage
                                    id="LbSelectIps"
                                    defaultMessage="Select Ips"
                                  />
                                </p>
                                <div className="bottom-border"></div>
                                {this.state.ipAddresslist.map((item) => {
                                  if (selectedOptions.length > 0) {
                                    selectedIDObj = selectedOptions.filter(
                                      (x) =>
                                        x.officeaddressipid
                                        == item.officeaddressipid,
                                    );
                                  }
                                  return (
                                    <MenuItem
                                      key={item.key}
                                      onClick={this.HandleMultiSelect.bind(
                                        this,
                                        item,
                                        "HtSelectIps",
                                      )}
                                      className={
                                        selectedIDObj.length > 0
                                          && selectedIDObj[0].officeaddressipid
                                          ? "select-list-item bottom-border inner-level-div-second-level"
                                          : "bottom-border inner-level-div-second-level"
                                      }
                                    >
                                      <ListItemText
                                        className="no-padding"
                                        primary={item.locationname}
                                        secondary={
                                          <React.Fragment>
                                            {`From ${item.ipaddressfrom} `} <br />
                                            {`To ${item.ipaddressto}`}{" "}
                                          </React.Fragment>
                                        }
                                      />

                                      {selectedIDObj.length > 0
                                        && selectedIDObj[0].officeaddressipid ? (
                                          <span
                                            onClick={() =>
                                              this.HandleMultiSelect.bind(
                                                this,
                                                item,
                                                "HtSelectIps",
                                              )
                                            }
                                            className="floatright selected-box"
                                          >
                                            <svg
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                            >
                                              <path d="M0 0h24v24H0z" fill="none" />
                                              <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                            </svg>
                                          </span>
                                        ) : (
                                          <span
                                            onClick={() =>
                                              this.HandleMultiSelect.bind(
                                                this,
                                                item,
                                                "HtSelectIps",
                                              )
                                            }
                                            className="not-selected-box"
                                          ></span>
                                        )}
                                    </MenuItem>
                                  );
                                })}
                              </MenuList>
                            </Collapse>
                            <div>
                              {this.state.ErList == true ? (
                                <span
                                  className="caption-error display-block"
                                  style={{ padding: "0 30px 10px 30px" }}
                                >
                                  <FormattedMessage
                                    id="ErSelectIp"
                                    defaultMessage="Please select IP"
                                  />
                                </span>
                              ) : (
                                  ""
                                )}
                            </div>
                          </div>

                          <div
                            className={
                              this.state.isiprestricted == false
                                ? "depedent-select-list select-list-item"
                                : "depedent-select-list"
                            }
                            onClick={this.SetFalse.bind(this)}
                          >
                            <span>
                              <FormattedMessage id="LbNo" defaultMessage="No" />
                            </span>
                            {this.state.isiprestricted == false ? (
                              <span className="floatright">
                                <img src={CheckImg} height="20" />
                              </span>
                            ) : (
                                <span className="not-selected"></span>
                              )}
                          </div>
                        </div>
                      ) : (
                          ""
                        )}
                    </div>
                  )}
              </div>
              {/* <div className="padding-top-30">
                                <Button

                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    onClick={this.OnNext.bind(this)}
                                >
                                    <FormattedMessage id="BtNext" defaultMessage="Next" />
                                </Button>
                            </div> */}
              {/* <div className="draftbutton-wrapper">
                                    <div className="draftclosebutton cursour-pointer" onClick={this.OnCancel.bind(this)}>X <span className="draftclosebutton-text"><FormattedMessage id="BtClose" defaultMessage="Close" /></span></div>

                                    <div className="draftbutton-innerwrapper">
                                        {this.state.isdraft == true ?
                                        <span className="draftbutton cursour-pointer" onClick={this.OnSave.bind(this, 'SaveAsDraft')}>
                                            <Done />
                                            <span className="draft-option"><FormattedMessage id="BtSaveAsDraft" defaultMessage="Save As Draft" /></span>
                                        </span>
                                        :
                                        <span className="draftbutton cursour-pointer" onClick={this.OnSave.bind(this, 'Save')}>
                                            <DoneAllIcon />
                                            <span className="draft-option"><FormattedMessage id="BtSave" defaultMessage="Save" /></span>
                                        </span>
                                        }
                                    </div>
                                </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Web.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  attendanceDeviceReducer: state.attendanceDeviceReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendanceDevice: (data) => AttendanceDevice(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(Web)));
